import { https } from "../http";
import store from "../store";
import { showError, showSuccess } from "../utils";
import {
  setSchedulerLoading,
  setShifts,
  setSchedulerSettings,
  setTemplates,
} from "../store/reducers/scheduler";

/* ---------------- shifts ---------------- */
const getShifts = async (params = {}) => {
  try {
    store.dispatch(setSchedulerLoading(true));
    const res = await https().get("/schedule/shifts", { params });
    store.dispatch(setShifts(res?.data?.data || []));
    store.dispatch(setSchedulerLoading(false));
    return res?.data?.data || [];
  } catch (error) {
    store.dispatch(setSchedulerLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return [];
  }
};

const getShift = async (id) => {
  try {
    const res = await https().get(`/schedule/shifts/${id}`);
    return res?.data?.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const createShift = async (data, callback) => {
  try {
    const res = await https().post("/schedule/shifts", data);
    showSuccess("Shift created");
    callback?.(res?.data?.data);
    return res?.data?.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const updateShift = async (id, data, callback) => {
  try {
    const res = await https().put(`/schedule/shifts/${id}`, data);
    callback?.(res?.data?.data);
    return res?.data?.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const deleteShift = async (id, scope = "single", callback) => {
  try {
    await https().delete(`/schedule/shifts/${id}`, { params: { scope } });
    showSuccess("Shift removed");
    callback?.();
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const addShiftNote = async (id, text, callback) => {
  try {
    const res = await https().post(`/schedule/shifts/${id}/notes`, { text });
    callback?.(res?.data?.data);
    return res?.data?.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const publishShifts = async (shiftIds, callback) => {
  try {
    const res = await https().post("/schedule/publish", { shiftIds });
    showSuccess("Schedule published");
    callback?.(res?.data?.data);
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const copyWeek = async (fromDate, toDate, callback) => {
  try {
    const res = await https().post("/schedule/copy-week", { fromDate, toDate });
    showSuccess(`${res?.data?.data?.copied || 0} shifts copied`);
    callback?.(res?.data?.data);
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const checkConflicts = async (data) => {
  try {
    const res = await https().post("/schedule/check-conflicts", data);
    return res?.data?.data?.warnings || [];
  } catch (error) {
    return [];
  }
};

const getAvailableStaff = async (params) => {
  try {
    const res = await https().get("/schedule/available-staff", { params });
    return res?.data?.data || [];
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return [];
  }
};

const exportSchedule = async (params = {}) => {
  try {
    const res = await https().get("/schedule/export", { params, responseType: "blob" });
    return res?.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

/* ---------------- settings ---------------- */
const getSchedulerSettings = async () => {
  try {
    const res = await https().get("/schedule/settings");
    store.dispatch(setSchedulerSettings(res?.data?.data));
    return res?.data?.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const updateSchedulerSettings = async (data, callback) => {
  try {
    const res = await https().put("/schedule/settings", data);
    store.dispatch(setSchedulerSettings(res?.data?.data));
    callback?.(res?.data?.data);
    return res?.data?.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

/* ---------------- templates ---------------- */
const getTemplates = async (facility) => {
  try {
    const res = await https().get("/schedule/templates", { params: facility ? { facility } : {} });
    store.dispatch(setTemplates(res?.data?.data || []));
    return res?.data?.data || [];
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return [];
  }
};
const createTemplate = async (data) => {
  try {
    const res = await https().post("/schedule/templates", data);
    return res?.data?.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const seedTemplates = async (templates) => {
  try {
    const res = await https().post("/schedule/templates/seed", { templates });
    return res?.data?.data || [];
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return [];
  }
};
const updateTemplate = async (id, data) => {
  try {
    const res = await https().put(`/schedule/templates/${id}`, data);
    return res?.data?.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const deleteTemplate = async (id) => {
  try {
    await https().delete(`/schedule/templates/${id}`);
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};


const schedulerService = {
  getShifts,
  getShift,
  createShift,
  updateShift,
  deleteShift,
  addShiftNote,
  publishShifts,
  copyWeek,
  checkConflicts,
  getAvailableStaff,
  exportSchedule,
  getSchedulerSettings,
  updateSchedulerSettings,
  getTemplates,
  createTemplate,
  seedTemplates,
  updateTemplate,
  deleteTemplate,
};

export default schedulerService;
